module.exports = __webpack_public_path__ + "img/store_setting.801204a2.png";